import { CancelButton, SaveButton } from '@core/components/Buttons';
import { FormDialogContent, SimpleDialog } from '@core/components/Dialog';
import { NumberInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { mensagemCampoObrigatorio } from '@core/util/mensagemUtil';
import { Grid } from '@material-ui/core';
import SelectFornecedor from 'app/components/Select/SelectFornecedor';
import { cancelarAlert } from 'app/services/alerts';
import { FormikProvider, useFormik } from 'formik';
import React, { useEffect } from 'react';
import { FaCalendarCheck } from 'react-icons/fa';
import * as yup from 'yup';
import { ImpostoAction } from '../../store/impostoAction';
import { useImposto } from '../../store/impostoContext';

function ImpostoCadastroModal() {
  const [state, dispatch] = useImposto();

  const schema = yup.object().shape({
    nome: yup
      .string()
      .required(mensagemCampoObrigatorio('o nome do imposto'))
      .min(3, 'É necessário informar pelo menos 3 caracteres no campo'),
    aliquota: yup.string().required(mensagemCampoObrigatorio('a alíquota')),
    fornecedor: yup
      .object()
      .nullable()
      .required(mensagemCampoObrigatorio('o fornecedor')),
  });

  const handleSalvar = () => {
    formik.validateForm().then((errors) => {
      if (Object.keys(errors).length === 0) {
        if (formik.values && formik.values.id) {
          ImpostoAction.atualizarRegistro(dispatch, formik.values, state.requestParams);
        } else {
          ImpostoAction.criarRegistro(dispatch, formik.values, state.requestParams);
        }
      }
    });
  };

  const formik = useFormik({
    initialValues: state.registro,
    validationSchema: schema,
    validationOnChange: false,
    onSubmit: handleSalvar,
  });

  const handleCancelar = () => {
    if (formik.dirty) {
      cancelarAlert({
        confirmar: async () => {
          dispatch(ImpostoAction.fecharModalCadastro());
        },
      });
    } else {
      dispatch(ImpostoAction.fecharModalCadastro());
    }
  };

  useEffect(() => {
    if (state.cadastrar) {
      formik.resetForm(state.registro);
    }
    // Efeito reativo apenas ao gatilho acima; incluir as demais reiniciaria o formulário durante a edição.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.cadastrar]);

  const _errors = {
    nome: (formik.submitCount > 0 || formik.touched.nome) && formik.errors.nome,
    fornecedor: (formik.submitCount > 0 || formik.touched.fornecedor) && formik.errors.fornecedor,
    codigo: (formik.submitCount > 0 || formik.touched.codigo) && formik.errors.codigo,
    aliquota: (formik.submitCount > 0 || formik.touched.aliquota) && formik.errors.aliquota,
    tipo: (formik.submitCount > 0 || formik.touched.tipo) && formik.errors.tipo,
  };

  return (
    <FormikProvider value={formik}>
      <SimpleDialog fullScreen open={state.cadastrar} onClose={handleCancelar}>
        <FormDialogContent
          onSubmit={formik.handleSubmit}
          fullScreen
          header={{
            title: 'Cadastro de imposto',
            icon: <FaCalendarCheck />,
            toolbar: (
              <>
                <CancelButton onClick={handleCancelar}>Cancelar</CancelButton>
                <SaveButton>Salvar</SaveButton>
              </>
            ),
          }}
          content={
            <Grid container spacing={3} className="mt-10">
              <Grid item xs={12} sm={4}>
                <TextInput
                  autoFocus
                  required
                  label="Nome do Imposto"
                  id="nome"
                  value={formik.values.nome}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  maxLength={100}
                  touched={!!_errors.nome}
                  error={_errors.nome}
                />
              </Grid>
              <Grid item xs={12} sm={8}>
                <SelectFornecedor
                  id="fornecedor"
                  handleChange={formik.handleChange}
                  handleBlur={formik.handleBlur}
                  fornecedor={formik.values?.fornecedor || ''}
                  touched={!!_errors.fornecedor}
                  error={_errors.fornecedor}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  label="Código do imposto"
                  id="codigo"
                  format="####"
                  value={formik.values.codigo}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  touched={!!_errors.codigo}
                  error={_errors.codigo}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <NumberInput
                  required
                  label="Alíquota (%)"
                  id="aliquota"
                  decimalScale={8}
                  decimalSeparator=","
                  allowNegative={false}
                  isAllowed={(values) => {
                    return !values.floatValue || values.floatValue <= 100;
                  }}
                  value={formik.values.aliquota}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  touched={!!_errors.aliquota}
                  error={_errors.aliquota}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <SelectInput
                  label="Tipo do imposto"
                  id="tipo"
                  onChange={formik.handleChange}
                  value={formik.values.tipo}
                  options={[
                    { id: 'DARF', title: 'DARF' },
                    { id: 'GPS', title: 'GPS' },
                    { id: 'IBSCBS', title: 'Guia Nacional IBS/CBS' },
                    { id: 'OUTROS', title: 'Outros impostos' },
                  ]}
                  touched={!!_errors.tipo}
                  error={_errors.tipo}
                />
              </Grid>
            </Grid>
          }
        />
      </SimpleDialog>
    </FormikProvider>
  );
}

export default ImpostoCadastroModal;
